export default "__VITE_ASSET__ChhKeYCb__"